import { render, staticRenderFns } from "./ClientFilter.vue?vue&type=template&id=162204be&scoped=true&"
import script from "./ClientFilter.vue?vue&type=script&lang=ts&"
export * from "./ClientFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162204be",
  null
  
)

/* custom blocks */
import block0 from "./ClientFilter.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports